/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivFleetVehicleInsuranceContractViewModelGen,
  MrfiktivFleetVehicleLeasingContractViewModelGen
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class FleetVehicleContracts<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet Vehicle Contracts
   * @name FleetVehicleContractControllerGetByVehicle
   * @summary (FLEET-VEHICLE-CONTRACT-READ) Get the contract for a specific vehicle
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/vehicle/{vehicleId}/contract
   * @secure
   * @response `200` `((MrfiktivFleetVehicleLeasingContractViewModelGen | MrfiktivFleetVehicleInsuranceContractViewModelGen))[]` The contracts of the vehicle
   */
  fleetVehicleContractControllerGetByVehicle = (
    partnerId: string,
    fleetId: string,
    vehicleId: string,
    params: RequestParams = {}
  ) =>
    this.http.request<
      (MrfiktivFleetVehicleLeasingContractViewModelGen | MrfiktivFleetVehicleInsuranceContractViewModelGen)[],
      any
    >({
      path: `/partner/${partnerId}/fleet/${fleetId}/vehicle/${vehicleId}/contract`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
